import {Component} from '@angular/core';

import {
  NavController, AlertController,
  LoadingController, Loading
} from 'ionic-angular';

import {AuthService} from '../../providers/auth-service'
import {LoginPage} from "../login/login";

@Component({
  selector: 'signup',
  templateUrl: 'signup.html'
})

export class SignupPage {
  loading: Loading;

  createSuccess = false;
  registerCredentials = {
    title:"",
    username: "",
    first_name: "",
    surname: "",
    phone_number: "",
    email: "",
    password: ""
  };

  constructor(private nav: NavController,
              private auth: AuthService,
              private alertCtrl: AlertController,
              private loadingCtrl: LoadingController) {
  }

  public register() {
    this.showLoading();

    this.auth.register(this.registerCredentials).subscribe(
      success => {
        if (success) {
          this.createSuccess = true;
          this.showPopup("Success", "Account created")
        } else {
          this.showPopup("Error", "Problem creating account")
        }
      }, error => {
        this.showError(error)
      });
  }

  showPopup(title, text) {

    let alert = this.alertCtrl.create({
      title: title,
      subTitle: text,
      buttons: [
        {
          text: 'OK',
          handler: data => {
            if (this.createSuccess) {
              this.nav.push(LoginPage)
            }
          }
        }
      ]
    });
    alert.present(prompt);
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }


  showError(text) {
    setTimeout(() => {
      this.loading.dismiss();
    })

    let alert = this.alertCtrl.create({
      title: 'Failed',
      subTitle: text,
      buttons: ['OK']
    });

    alert.present(prompt)
  }

}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts